import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Table, Row, Col, Form, Divider, Button } from '_zari/core'

import { TiposCentrosCosto } from 'constants/index'

import { IdGen } from 'utils'

import * as CentrosCostoService from 'services/centrosCosto.service'
import * as FactoresCostoService from 'services/factoresCosto.service'

const portletBreadcrumbs = [{ name: 'Factores Costos Indirectos' }]

const MainPage = () => {
  const __zariContext = React.useContext(ZariContext)

  const [__keyFragment, setKeyFragment] = React.useState(IdGen.newId())

  const [centrosCostosNivelUno, setCentrosCostosNivelUno] = React.useState([])
  const [centroCostoNivelUnoSeleccionado, setCentroCostoNivelUnoSeleccionado] = React.useState('')

  const [centrosCostosNivelDos, setCentrosCostosNivelDos] = React.useState([])
  const [centroCostoNivelDosSeleccionado, setCentroCostoNivelDosSeleccionado] = React.useState('')

  const [repartos, setRepartos] = React.useState(new Map())

  React.useEffect(() => {
    CentrosCostoService.obtenertTodosxNivel(1).then(({ data }) => {
      setCentrosCostosNivelUno(data)
    })
  }, [])

  const refrescarCentrosNivel2 = React.useCallback(idNodoPadre => {
    CentrosCostoService.obtenerNivel2xIdNodoPadrexTipoAsSelect({
      idNodoPadre: idNodoPadre,
      tipo: TiposCentrosCosto.INDIRECTO
    })
      .then(({ data }) => {
        setCentrosCostosNivelDos(data)
      })
      .catch(() => {
        setCentrosCostosNivelDos([])
      })
  }, [])

  const onChangeCentroNivelUno = React.useCallback(
    e => {
      setCentroCostoNivelUnoSeleccionado(e.target.value)
      setRepartos(new Map())
      if (e.target.value) {
        refrescarCentrosNivel2(e.target.value)
      } else {
        setCentrosCostosNivelDos([])
      }
    },
    [refrescarCentrosNivel2]
  )

  const onChangeCentroNivelDos = React.useCallback(e => {
    setCentroCostoNivelDosSeleccionado(e.target.value)
    setRepartos(new Map())
  }, [])

  const clickBuscar = React.useCallback(() => {
    setRepartos(new Map())

    if (!centroCostoNivelDosSeleccionado) {
      __zariContext.snack('warning', 'Seleccionar centro de nivel 2 para continuar.')
      return 
    }

    FactoresCostoService.obtenerAsTablaFactores(centroCostoNivelDosSeleccionado).then(({ data }) => {
      if (data) {
        const nuevosValores = new Map()
        for (let i = 0; i < data.length; i++) {
          const element = data[i]
          nuevosValores.set(element._idCentroCostoNivel2, {
            _idCentroCostoNivel2: element._idCentroCostoNivel2,
            codigo: element.codigo,
            descripcion: element.descripcion,
            factor: element.factor
          })
        }
        setKeyFragment(IdGen.newId())
        setRepartos(nuevosValores)
      }
    })
  }, [__zariContext, centroCostoNivelDosSeleccionado])

  const onChangeFactor = React.useCallback((e, _idCentroCostoNivel2) => {
    const nuevoValor = e.target.value
    setRepartos(prev => {
      const nuevoMap = new Map(prev)
      nuevoMap.set(_idCentroCostoNivel2, {
        ...nuevoMap.get(_idCentroCostoNivel2),
        factor: nuevoValor
      })
      return nuevoMap
    })
  }, [])

  const clickReplicar = React.useCallback(
    factor => {
      const nuevoMap = new Map()

      const keys = [...repartos.keys()]
      for (let i = 0; i < keys.length; i++) {
        const eleKey = keys[i]

        nuevoMap.set(eleKey, {
          ...repartos.get(eleKey),
          factor: factor
        })
      }

      setRepartos(nuevoMap)
    },
    [repartos]
  )

  const clickGuardarCambios = React.useCallback(() => {
    const salida = []

    const keys = [...repartos.keys()]
    for (let i = 0; i < keys.length; i++) {
      const eleKey = keys[i]
      const factor = parseFloat(repartos.get(eleKey).factor || '0')

      if (factor !== 0) {
        salida.push({
          _idCentroCostoNivel2: centroCostoNivelDosSeleccionado,
          _idCentroCostoFactorNivel2: eleKey,
          factor: factor
        })
      }
    }

    FactoresCostoService.actualizarMasivo(salida)
      .then(() => {
        __zariContext.snack('success', 'Factores actualizados.')
        setRepartos(new Map())
        setKeyFragment(IdGen.newId())
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [repartos, __zariContext, centroCostoNivelDosSeleccionado])

  const clickCancelar = React.useCallback(() => {
    setRepartos(new Map())
    setKeyFragment(IdGen.newId())
  }, [])

  return (
    <>
      <Portlet>
        <Portlet.Header title='Factores Costos Indirectos' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Row className='zari-slim-form'>
            <Col md={2}>
              <Form.Group>
                <Form.Label text='CENTRO NIVEL 1' md={12} />
                <Col md={12}>
                  <Form.Select
                    id='select-centro-nivel-1'
                    name='select-centro-nivel-1'
                    value={centroCostoNivelUnoSeleccionado}
                    onChange={onChangeCentroNivelUno}
                  >
                    <option value=''>Seleccionar</option>
                    {centrosCostosNivelUno.map(y => (
                      <option key={y._id} value={y._id}>{`${y.codigo} - ${y.descripcion}`}</option>
                    ))}
                  </Form.Select>
                </Col>
              </Form.Group>
            </Col>
            {centroCostoNivelUnoSeleccionado && (
              <Col md={2}>
                <Form.Group>
                  <Form.Label text='CENTRO NIVEL 2' md={12} />
                  <Col md={12}>
                    <Form.Select
                      id='select-centro-nivel-2'
                      name='select-centro-nivel-2'
                      value={centroCostoNivelDosSeleccionado}
                      onChange={onChangeCentroNivelDos}
                    >
                      <option value=''>Seleccionar</option>
                      {centrosCostosNivelDos.map(y => (
                        <option key={y._id} value={y._id}>{`${y.codigo} - ${y.descripcion}`}</option>
                      ))}
                    </Form.Select>
                  </Col>
                </Form.Group>
              </Col>
            )}
            <Col md={1}>
              <Form.Group>
                <Form.Label text='.' md={12} />
                <Col md={12}>
                  <Button tiny block onClick={clickBuscar}>
                    Buscar
                  </Button>
                </Col>
              </Form.Group>
            </Col>
          </Row>
          {repartos.size > 0 && (
            <React.Fragment key={__keyFragment}>
              <Row>
                <Col md={12}>
                  <Divider />
                  <Table
                    filas={[...repartos.values()]}
                    headRows={[
                      {
                        label: 'CODIGO',
                        width: 100
                      },
                      {
                        label: 'DESCRIPCION'
                      },
                      { label: 'FACTOR', width: 100 },
                      {
                        label: ''
                      }
                    ]}
                    maxRowsShown={15}
                    rowTemplate={row => (
                      <Table.Row key={row._idCentroCostoNivel2}>
                        <Table.Cell>{row.codigo || ''}</Table.Cell>
                        <Table.Cell>{row.descripcion || ''}</Table.Cell>
                        <Table.Cell>
                          <Form.InputText
                            id={`itext-${row._idCentroCostoNivel2}`}
                            name={`itext-${row._idCentroCostoNivel2}`}
                            value={repartos.get(row._idCentroCostoNivel2).factor}
                            onChange={e => onChangeFactor(e, row._idCentroCostoNivel2)}
                          />
                        </Table.Cell>
                        <Table.Cell>
                          <Button tiny outline onClick={() => clickReplicar(row.factor)}>
                            Replicar
                          </Button>
                        </Table.Cell>
                      </Table.Row>
                    )}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Button onClick={clickCancelar} tiny block outline color='secondary'>
                    Cancelar
                  </Button>
                </Col>
                <Col md={6}>
                  <Button onClick={clickGuardarCambios} tiny block>
                    Guardar Cambios
                  </Button>
                </Col>
              </Row>
            </React.Fragment>
          )}
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default React.memo(MainPage)
